import { isAxiosError } from 'axios';

export function isNotFoundAxiosError(error: unknown): boolean {
  return isAxiosError(error) && (error.code === '404' || error.response?.status === 404);
}
